import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AppConfigState } from '@nibtravel/shared/util/app-config';
import { IContentfulParams } from '@nibtravel/shared/util/models';
import { Entry } from 'contentful';
import { Observable } from 'rxjs';

import { ContentfulService } from './contentful.service';
import { ContentTypes } from './models/content.types';

@Injectable({ providedIn: 'root' })
export class ContentfulDataService {
  constructor(
    private store: Store,
    private contentfulService: ContentfulService
  ) {}

  get brand(): string {
    return this.store.selectSnapshot(AppConfigState.getBrand);
  }

  get fallbackBrand(): string {
    return 'default';
  }

  getContent<T>(
    contentType: ContentTypes | string,
    params: IContentfulParams
  ): Observable<Entry<T> | undefined> {
    return this.contentfulService.getZone(
      contentType,
      this.brand,
      params.zone,
      params.allowFallbackBrand === true ? this.fallbackBrand : undefined
    );
  }
}
